module.exports = __webpack_public_path__ + "media/images/icons/cookies-608ea3c47b395cf864f1e5887b8ca08c.svg";